import gql from 'graphql-tag';
import fragments from './fragments';

const queries = {};

queries.appState = gql`
    query {
        currentUser {
            ...appStateUserFields
        }
    }

${fragments.appStateUserFields}`;

queries.beacons = gql`
    query getBeaconData($organizationId: ID!){
        beacons (organizationId: $organizationId){
            id
            minor
            name
            code
            batteryLevel
        }
    }
`;

queries.savedCouponsForDevice = gql`
    query getSavedCouponsForDevice ($deviceToken: String!){
        devices(token: $deviceToken) {
            savedCoupons {
                ...completeCouponFields
            }
        }
    }
${fragments.completeCouponFields}`;

queries.savedCouponIds = gql`
    query getSavedCouponIds ($deviceToken: String!){
        devices(token: $deviceToken) {
            savedCoupons {
              id
            }
        }
    }
`;

queries.campaign = gql`
    query getCampaign ($id: ID!){
        campaign(id: $id) {
            ...campaignFields
        }
    }
${fragments.campaignFields}`;

queries.todaysCoupons = gql`
    query getTodaysCoupons ($deviceToken: String!){
        todaysCoupons (deviceToken: $deviceToken){
          ...completeCouponFields
        }
    }
${fragments.completeCouponFields}`;

queries.stats = gql`
    query getStats ($statsInput: StatsInput!){
        stats (statsInput: $statsInput){
            redeemedCoupons
            clickThroughRate
            averageCouponViewTime
            sentNotifications
            uniqueVisitors
            coupons {
                ...completeCouponFields
            }
        }
    }

${fragments.completeCouponFields}`;

queries.statsAvailable = gql`
    query getStatsAvailable {
        statsAvailable
    }
`;

queries.currencies = gql`
    query getCurrencies {
      currencys {
        id
        name
        symbol
      }
    }
`;

queries.dashboardStats = gql`
    query {
        realtimeStats {
            hour
            uniqueVisitors
            sentNotifications
            clickThroughRate
        }
        stats {
            uniqueVisitors
            sentNotifications
            averageCouponViewTime
            redeemedCoupons
            clickThroughRate
        }
    }
`;

export default queries;
